var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link-back",attrs:{"to":{
    name: 'autoinformer.campaign.edit',
    params: { id: _vm.id, tutorial: !!this.$route.params.tutorial, from_scheme: true }
  }}},[_c('img',{staticClass:"link-back__img",attrs:{"src":"/img/icons/header/back.svg","alt":"Стерлка назад"}}),_vm._v(" "+_vm._s(_vm.$t('shared.component.button.back'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }